import { jsxs as o, jsx as e } from "react/jsx-runtime";
import m from "classnames";
import "./main.scss";
const t = ({
  title: i,
  secondaryTitle: s = void 0,
  className: a = void 0
}) => /* @__PURE__ */ o("div", { className: m("sds_page-title", a), children: [
  /* @__PURE__ */ e("span", { className: "font-semi-bold--uppercase", children: i }),
  s && /* @__PURE__ */ e("span", { children: ` | ${s}` })
] });
export {
  t as PageTitle
};
//# sourceMappingURL=index.js.map
